import type { Timestamp } from 'firebase/firestore';
import type { AuditoriaAtor } from './solicitacao.types';

/**
 * Postagem nas Observações da Solicitação (si_solicitacoes/{id}/comentarios) — como o
 * acompanhamento de um chamado no GLPI: cada pessoa posta, fica registrado quem e quando.
 * Qualquer um que vê a Solicitação pode postar; só o autor edita ou exclui a própria
 * postagem (ver firestore.rules — autoria conferida por `autorEmail`).
 */
export interface ComentarioSolicitacao {
  id: string;
  texto: string;
  autor: AuditoriaAtor;
  /** E-mail de login de quem postou — é o que as regras usam pra saber quem é o autor. */
  autorEmail: string;
  criadoEm: Timestamp | null;
  /** Preenchido quando o autor edita o texto — a tela mostra "(editado)". */
  editadoEm?: Timestamp | null;
}

export const COMENTARIO_SOLICITACAO_MAX_CARACTERES = 5000;
